import { LitElement, html, css, unsafeCSS } from 'lit'
import { customElement } from 'lit/decorators.js'
import './components/app-router.js'
import './components/app-header.js'
import styles from './app.css?inline'

/**
 * Main application component
 * Handles routing and layout
 */
@customElement('app-root')
export class App extends LitElement {
  static styles = css`${unsafeCSS(styles)}`

  render() {
    return html`
      <app-header></app-header>
      <main>
        <app-router></app-router>
      </main>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'app-root': App
  }
}
